import "@story/story_assets/dom_extend";
import { parseLocalizedInt, formatCurrency } from "../utils/numbers";

document.addEventSelectorListener("change focusout", "input[data-mask='currency']", function(event, target) {
	let value = parseLocalizedInt(target.value);
	let element = target.parentElement.querySelector(".form-mask-input");
	element.innerHTML = formatCurrency(value);
});
